export var VerificationFailureReason;
(function (VerificationFailureReason) {
    /** Default value - means no failure */
    VerificationFailureReason["UNSPECIFIED"] = "UNSPECIFIED";
    /** Bad verification code */
    VerificationFailureReason["BAD_CODE"] = "BAD_CODE";
    /** Verification code was not found */
    VerificationFailureReason["NOT_FOUND"] = "NOT_FOUND";
    /** Error while sending the code to the user */
    VerificationFailureReason["SEND_CODE_ERROR"] = "SEND_CODE_ERROR";
})(VerificationFailureReason || (VerificationFailureReason = {}));
export var PhoneDeliveryOption;
(function (PhoneDeliveryOption) {
    /** Default value - The code will be sent by an SMS */
    PhoneDeliveryOption["SMS"] = "SMS";
    /** The code will be sent by a voice call */
    PhoneDeliveryOption["VOICE_CALL"] = "VOICE_CALL";
})(PhoneDeliveryOption || (PhoneDeliveryOption = {}));
export var ApprovalChallengeStatus;
(function (ApprovalChallengeStatus) {
    ApprovalChallengeStatus["PENDING_APPROVAL"] = "PENDING_APPROVAL";
    ApprovalChallengeStatus["DECLINED"] = "DECLINED";
    ApprovalChallengeStatus["APPROVED"] = "APPROVED";
    ApprovalChallengeStatus["EXPIRED"] = "EXPIRED";
})(ApprovalChallengeStatus || (ApprovalChallengeStatus = {}));
//# sourceMappingURL=types.impl.js.map